<template>
  <!-- 股本信息 -->
  <div>
    <el-table border :data="tableData" header-cell-class-name="table-header">
      <el-table-column prop="fullName" :label="$t('enroll.establish.shareholderName')" align="center"></el-table-column>
      <el-table-column prop="typeOfShares" :label="$t('enroll.intitle.stock')" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.typeOfShares == 'Ordinary'">
            {{ $t("enroll.intitle.stockOption01") }}
          </p>
          <p v-if="scope.row.typeOfShares == 'Preference'">
            {{ $t("enroll.intitle.stockOption02") }}
          </p>
          <p v-if="scope.row.typeOfShares == 'Others'">
            {{ $t("enroll.intitle.stockOption03") }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="quantityOfSharesAllotted" :label="$t('enroll.intitle.ratio')" align="center"></el-table-column>
      <el-table-column prop="amountOfPaidUpShareCapital" :label="$t('enroll.intitle.capital')" align="center" v-if="!isMalaysia">
        <template slot-scope="scope">
          <p v-if="formatAmount(scope.row.amountOfPaidUpShareCapital)">
            {{ scope.row.amountOfPaidUpShareCapital.split(" ")[0] }}
            {{ scope.row.amountOfPaidUpShareCapital.split(" ")[1] | thousandth }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="amountOfPaidInShareCapital"
        :label="isMalaysia ? $t('enroll.intitle.malaysia.paidInCapital') : $t('enroll.intitle.paidInCapital')"
        align="center"
      >
        <template slot-scope="scope">
          <p v-if="formatAmount(scope.row.amountOfPaidInShareCapital)">
            {{ scope.row.amountOfPaidInShareCapital.split(" ")[0] }}
            {{ scope.row.amountOfPaidInShareCapital.split(" ")[1] | thousandth }}
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="sharesHoldInTrust" :label="$t('enroll.intitle.hold')" align="center" v-if="!isMalaysia">
        <template slot-scope="scope">
          <p v-if="scope.row.sharesHoldInTrust == 1">{{ $t("common.yes") }}</p>
          <p v-if="scope.row.sharesHoldInTrust == 0">{{ $t("common.no") }}</p>
        </template>
      </el-table-column>
    </el-table>

    <template v-if="!isReadonly">
      <el-button plain icon="el-icon-edit" type="primary" @click="toEdit" class="mt26 fs12" v-if="applymentDetail.id">{{ $t("common.button.capital") }}</el-button>
    </template>
  </div>
</template>

<script>
import filtersMixin from "@/mixins/filtersMixin";
import { mapState } from "vuex";
export default {
  name: "ShareholdInformation",
  mixins: [filtersMixin],
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    /** 是否马来西亚（隐藏注册资本/信托列，使用马来西亚专属实收资本文案） */
    isMalaysia: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    /** 从 companyMemberList 中提取非DIRECTOR成员的shares，展平为表格数据（使用接口原始字段） */
    tableData() {
      const list = this.applymentDetail.companyMemberList || [];
      const result = [];
      for (let i = 0; i < list.length; i++) {
        const member = list[i];
        if (member.positionHeld === "DIRECTOR") continue;
        const sharesInfo = member.sharesInfo || [];
        for (let j = 0; j < sharesInfo.length; j++) {
          result.push({
            fullName: member.fullName,
            ...sharesInfo[j],
          });
        }
      }
      return result;
    },
  },
  methods: {
    formatAmount(val) {
      return val && val.split(" ")[0] && val.split(" ")[1];
    },
    onInput(val) {
      this.$emit("input", val);
    },
    // 跳转编辑股本信息
    toEdit() {
      this.$router.push({
        path: "/enroll/intitle",
        query: { id: this.applymentDetail.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
